module.exports = __webpack_public_path__ + "static/media/skill2_pos_en.8651f71d.txt";